<template>
  <v-text-field
    :name="name"
    :label="label"
    v-model="amountFieldValueComputed"
    outlined
    v-money="money"
    dense
    prefix="$"
    :value="amountFieldValueComputed"
  />
</template>

<script>
import Vue from 'vue';
import { VMoney } from 'v-money';

export default Vue.extend({
  name: 'Amount',
  data() {
    return {
      amountFieldValue: 0,
      money: {
        decimal: '.',
        thousands: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
    };
  },
  computed: {
    amountFieldValueComputed: {
      get() {
        return this.originalAmount;
      },
      set(value) {
        this.$emit('updateAmountFieldValue', value);
      },
    },
  },
  props: {
    label: {
      type: String,
      required: false,
    },
    name: { // refundAmount
      type: String,
      required: false,
    },
    originalAmount: { // transaction.amount
      type: Number,
      required: false,
    },
  },
  directives: { money: VMoney },
});
</script>
